'use client';
import React from 'react';
import { motion } from 'framer-motion';
import Image from 'next/image';
import Link from 'next/link';

const galleryImages = [
    { src: "/images/infrastructure/ryobi-780G.png", span: "md:col-span-2 md:row-span-2", title: "Digital Precision" },
    { src: "/images/infrastructure/flexo-press-multi.png", span: "md:col-span-1 md:row-span-1", title: "Industrial Scale" },
    { src: "/images/production-floor-new.png", span: "md:col-span-1 md:row-span-2", title: "Production Floor" },
    { src: "/images/warehouse-labels-portfolio.png", span: "md:col-span-1 md:row-span-1", title: "Warehousing" },
];

const Gallery = () => {
    return (
        <section className="bg-white pt-24 pb-24">
            <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16 px-4">
                    <h2 className="text-3xl md:text-5xl font-display font-bold text-[#09172e] mb-6">
                        Production Floor Insights
                    </h2>
                    <p className="text-gray-600 max-w-2xl mx-auto">
                        Experience the scale and technological sophistication of the Royal Prime Labels facility through our production showcase.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-4 md:grid-rows-2 gap-4 h-auto md:h-[800px]">
                    {galleryImages.map((img, index) => {
                        const isMachine = img.src.includes('machine-') || img.src.includes('ryobi') || img.src.includes('flexo');
                        return (
                            <motion.div
                                key={index}
                                className={`relative overflow-hidden rounded-xl group ${img.span} aspect-[4/3] md:aspect-auto border border-gray-200 shadow-[0_20px_50px_rgba(0,0,0,0.1)] transition-all duration-300 hover:shadow-[0_30px_70px_rgba(0,0,0,0.15)] ${isMachine ? 'bg-[#f8f9fa]' : 'bg-gray-100'}`}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: index * 0.1 }}
                            >
                                <Image
                                    src={img.src}
                                    alt={img.title}
                                    fill
                                    className={`${isMachine ? 'object-contain p-4' : 'object-cover'} transform group-hover:scale-105 transition-transform duration-700`}
                                />
                                {/* Overlay - Lighter gradient for light theme */}
                                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-40 group-hover:opacity-60 transition-opacity duration-300" />

                                <div className="absolute bottom-6 left-6">
                                    <span className="text-xs font-semibold tracking-widest text-white/90 uppercase mb-2 block opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-all duration-300 transform translate-y-0 md:translate-y-2 md:group-hover:translate-y-0">
                                        Quality Assured
                                    </span>
                                    <h3 className="text-xl font-display font-bold text-white transform translate-y-0 md:translate-y-4 md:group-hover:translate-y-0 transition-transform duration-300">
                                        {img.title}
                                    </h3>
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Gallery;
